import React from "react";
import ReactDOM from "react-dom/client";
import "./css/index.css";
import "./css/RevealPack.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));

// Console Security Warning
(() => {
    const title = "%cWarning!";
    const titleStyle =
        "font-size:56px;font-weight:900;color:#ff3b30;text-shadow:2px 2px 0 #000;";
    const msgStyle =
        "font-size:16px;color:#fff;padding:10px 12px;border-radius:6px;";

    const msg =
        "You opened the browser console.\n" +
        "Do NOT paste code you do not understand.\n" +
        "Never share your seed phrase / private key / tokens.\n" +
        "If someone told you to do this, it's likely a scam.";

    console.log(title, titleStyle);
    console.log("%c" + msg, msgStyle);
})();

root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
